export default {
  props: {
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    labelColor: {
      type: String,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    cssClass: {
      type: String,
    },
    icon: {
      type: String,
    },
    clickValue: {
      type: [String, Number, Object, Array],
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
    }
  },
  methods: {
    onClick(val) {
      if (this.to) {
        this.$router.push(this.to);
        return;
      }

      const value = (this.clickValue) ? this.clickValue : this.value;
      this.$emit('click', value);
    }
  }
}
